import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=7c4fb318&scoped=true&"
import script from "./Drug.vue?vue&type=script&lang=js&"
export * from "./Drug.vue?vue&type=script&lang=js&"
import style0 from "./Drug.vue?vue&type=style&index=0&id=7c4fb318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4fb318",
  null
  
)

export default component.exports